import { NgModule } from '@angular/core';

import { UrlImagePipe } from './url-image.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { SafePipe } from './safe.pipe';
import { StripTagsPipe } from './strip-tags.pipe';


const PIPES = [
  UrlImagePipe,
  StripHtmlPipe,
  SafePipe,
  StripTagsPipe
];

@NgModule({
  declarations: PIPES,
  exports: PIPES
})
export class PipesModule {
}
